<template>
  <div>
    <table-card
      :items="publishers"
      :fields="publisherFields"
      title="Publishers">
      <template v-slot:empty="scope">
        No publishers found
      </template>
      <template v-slot:cell(company_id)="data">
        <b-badge>{{ data.value }}</b-badge>
      </template>
      <template v-slot:cell(domain)="data">
        <b-btn variant="link" target="_blank" class="p-0" :href="'//' + data.value">{{ data.value }}</b-btn>
      </template>
      <template v-slot:cell(settings)="data">
        <div class="float-right hidden-button-group">
          <icon-button :to="{ name: 'PublisherSettings', params: { cid: data.item.company_id } }" class="mr-2" icon="icon-Settings" variant="outline-border"
                       tooltip="Settings"></icon-button>
          <icon-button :to="{ name: 'PublisherMediums', params: { cid: data.item.company_id } }" icon="icon-Mediums" variant="outline-border"
                       tooltip="Mediums"></icon-button>
        </div>
      </template>
    </table-card>

  </div>
</template>

<script>
    import {PublisherApi} from '@/publisher/api'
    import TableCard from '@/components/TableCard'

    export default {
        created() {
          PublisherApi.listPublishers().then((pubs) => this.publishers = pubs)
        },
        data() {
            return {
                publishers: [],
                publisherFields: [
                    {key: 'company_id', sortable: true},
                    {key: 'name', tdClass: 'majorField', sortable: true},
                    {key: 'domain', tdClass: 'minorField', sortable: true},
                    {key: 'settings', label: ''}
                ],
            }
        },
        components: {
            TableCard
        }
    }
</script>



// WEBPACK FOOTER //
// src/admin/pages/PublisherList.vue